import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { alphaNumericNormalizer, trimNormalizer } from "validators";
import { maxLength50, required } from "validators/validation";

type TerminalDevicesProps = {
	isLoading: boolean;
	terminalDeviceFields: any;
	sectionName: string;
};

const TerminalDevices = ({
	isLoading,
	terminalDeviceFields,
	sectionName,
}: TerminalDevicesProps) => {
	const {
		register,
		watch,
		setValue,

		formState: { errors },
	} = useFormContext();

	if (
		Array.isArray(terminalDeviceFields) &&
		terminalDeviceFields?.length > 0
	) {
		return (
			<div data-autotest="terminalDevicesSection">
				<Row>
					{terminalDeviceFields.map((device, index) => {
						const isEvenCol = index % 2 === 0;
						const labelName = device?.name
							? device?.name === "Other"
								? ""
								: `(${device?.name})`
							: "";

						const defaultSerialNumber = watch(
							`${sectionName}.terminalDevices.${index}.serialNumber`,
						);

						device.serialNumber = defaultSerialNumber;

						setValue(
							`${sectionName}.terminalDevices.${index}`,
							device,
						);

						return (
							<React.Fragment key={`${device?.ide}key`}>
								<Col
									className={`col-md-5 form-group ${
										isEvenCol
											? "offset-md-0"
											: "offset-md-2"
									} `}
								>
									<HookFormInputGroup
										name={
											`${sectionName}.terminalDevices.${index}.serialNumber` as const
										}
										register={register}
										label={`Serial # ${labelName}`}
										colInput={6}
										colLabel={6}
										key={`${device?.id}Key`}
										blurLoading={isLoading}
										autoComplete="off"
										validator={{ maxLength50, required }}
										normalize={alphaNumericNormalizer}
										normalizeOnBlur={trimNormalizer}
										errors={errors}
										defaultValue={
											device?.serialNumber ||
											defaultSerialNumber
										}
										showRequiredMark
									/>
									<HookFormInputGroup
										name={`${sectionName}.terminalDevices.${index}.typeId`}
										register={register}
										defaultValue={device?.typeId}
										hidden
									/>
									<HookFormInputGroup
										name={`${sectionName}.terminalDevices.${index}.id`}
										register={register}
										defaultValue={device?.id}
										hidden
									/>
								</Col>
							</React.Fragment>
						);
					})}
				</Row>
			</div>
		);
	} else {
		return null;
	}
};

export default TerminalDevices;
